import { storageKeys } from '@/constants/storage';

import { createPaymentReturnStorage } from './paymentReturnStorage';
import type { StorageAdapter } from './paymentReturnStorage';

export type CashAppPendingParams = {
  shopId: string;
  shopRoute: string;
  cartId: string;
  barberId?: string;
  promoId?: string;
  clientSecret: string;
  customer: {
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    preferredLanguage: string;
  };
  createdAt: number;
};

function isCashAppPendingParams(data: unknown): data is CashAppPendingParams {
  if (typeof data !== 'object' || data === null) return false;
  const obj = data as Record<string, unknown>;
  const customer = obj.customer as Record<string, unknown> | undefined;
  return (
    typeof obj.shopId === 'string' &&
    typeof obj.shopRoute === 'string' &&
    typeof obj.cartId === 'string' &&
    (obj.barberId === undefined || typeof obj.barberId === 'string') &&
    (obj.promoId === undefined || typeof obj.promoId === 'string') &&
    typeof obj.clientSecret === 'string' &&
    typeof obj.createdAt === 'number' &&
    typeof customer === 'object' &&
    customer !== null &&
    typeof customer.email === 'string' &&
    typeof customer.firstName === 'string' &&
    typeof customer.lastName === 'string' &&
    typeof customer.phone === 'string' &&
    typeof customer.preferredLanguage === 'string'
  );
}

const localStorageAdapter: StorageAdapter = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
};

const cashAppStorage = createPaymentReturnStorage(
  storageKeys.cashAppPending,
  isCashAppPendingParams,
  localStorageAdapter,
);

export const getCashAppPaymentFromSession = cashAppStorage.get;
export const saveCashAppPaymentToSession = cashAppStorage.set;
export const clearCashAppPaymentFromSession = cashAppStorage.clear;
